export default __webpack_public_path__ + "static/media/new_checkmark_selected.8129a41c.svg";